import { combineReducers } from "redux";
import posts from "./reducers/rootReducer";

export default combineReducers({
  posts
});
